<template>

	<div class="full" style="background-color: white;">
		<template v-if="device!='pc'">
			<div class="full" style="overflow: hidden;">
				<div class="full flex" style="flex-direction: column;overflow: hidden;">
					<div class="full" style="flex: 1;position: relative;background-color: white;" ref="formmain">
						<slot name='main'></slot>
					</div>
					<div>
						<el-collapse-transition>
							<div v-if="controllShow">
								<template>
									<!-- <van-divider>{{(flowprogressid==0 || isfirstnode)?'发起':'协同'}}</van-divider> -->
									<van-divider v-if="flowid">{{(flowprogressid==0 || isfirstnode)?'发起':'协同'}}</van-divider>
									<div class="flex">
										<div style="flex: 1;">
											<comment ref="commentRef" :id="id" :name="name" :flowprogressid="flowprogressid"
												:controlltype="controlltype" :flowprogressType="flowprogressType" />
										</div>
										<van-button type="default" style="flex: 1;padding: 0;" @click="flowprogressShow"
											text="流程">
										</van-button>
										<template v-if="cooperateButton">
											<van-button type="default" style="flex: 1;padding: 0;" @click="reback" text="退回">
											</van-button>
											<van-button type="default" style="flex: 1;padding: 0;" @click="forward" text="转发">
											</van-button>
											<van-button type="default" style="flex: 1;padding: 0;" @click="deleteflow"
												text="撤销">
											</van-button>
										</template>
									</div>
								</template>
							</div>
						</el-collapse-transition>
						<slot name='footer'></slot>
					</div>
				</div>
			</div>
			
			<flowdetailphone-index :flowprogressContent="flowprogressContent" ref="flowdetailIndex" :dataid="id" :moduleName="name" :isflow="isflow"  />
<!-- 
			<van-popup v-model="flowprogressShow" :style="{ height: '50%' ,width:'90%'}" :lazy-render="true"
				get-container="body" :safe-area-inset-bottom="true" @open="onFlowprogressShow">
				<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
					<div class="full"
						style="position: relative;flex: 1;box-sizing: border-box;padding: 10px;overflow: auto;">
						<van-steps direction="vertical" :active="flowprogressContent.length-1">
							<van-step v-for="(item,index) in flowprogressContent" :key="index">
								<p>{{item.title}}</p>
								<p>{{item.time}}</p>
							</van-step>
						</van-steps>
					</div>
					<van-button type="default" @click="flowprogressShow=false" block>返回</van-button>
				</div>
			</van-popup> -->

			<van-popup v-model="rebackShow" :style="{ height: '90%' ,width:'90%'}" :lazy-render="true"
				get-container="body" :safe-area-inset-bottom="true">
				<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
					<div class="full" style="position: relative;flex: 1;">
						<reback ref="reback" :flowprogress="flowprogress" @back="rebackSubmit" @error="rebackError" />
					</div>
				</div>
			</van-popup>

			<van-popup v-model="rebackShow" :style="{ height: '90%' ,width:'90%'}" :lazy-render="true"
				get-container="body" :safe-area-inset-bottom="true">
				<div class="full flex" style="flex-direction: column;align-items: center;justify-content: center;">
					<div class="full" style="position: relative;flex: 1;">
						<reback ref="reback" :flowprogress="flowprogress" @back="rebackSubmit" @error="rebackError" />
					</div>
				</div>
			</van-popup>

			<slot name="load"></slot>
		</template>



		<template v-else>
			<div class="full flex" style="overflow: hidden;flex-direction: row;">
				<div style="flex: 1;position: relative;">
					<div class="left_container full flex" style="flex-direction: column;">
						<div class="left_header" style="z-index: 10;" v-if="isflow">
							<div style="width: 100%;height: 20px;">
								<slot name="title"></slot>
							</div>
							<div style="width: 100%;">
								<div style="float: right;">
									<el-badge style="margin-right: 10px;">
										<vxe-button content="流程模拟" status="warning" size="mini"
											@click="flowsimulate">
										</vxe-button>
									</el-badge>
									<el-badge style="margin-right: 10px;">
										<vxe-button content="流程详情" status="primary" size="mini"
											@click="flowprogressShow">
										</vxe-button>
									</el-badge>
									<comment ref="commentRef" :id="id" :name="name" :controlltype="controlltype"
										:flowprogressType="flowprogressType" :flowprogressid="flowprogressid" />
									<!-- 									<el-badge :value="commentcount?commentcount:null" style="margin-right: 10px;">
										<vxe-button content="处理意见" status="danger" size="mini"
											@click="commentShow=true">
										</vxe-button>
									</el-badge> -->
								</div>
							</div>
						</div>
						<div
							style="flex: 1;overflow: auto;width: 100%;position: relative;background-color: rgb(233, 233, 235);">
							<div class="full flex"
								style="box-sizing: border-box;flex-direction: column;justify-content: center;align-items: center;padding: 40px;"
								:style="{minWidth:width+'px',minHeight:height+'px'}">
								<div style="position: relative;box-shadow: 0px 0px 4px grey;width: 100%;height: 100%;"
									:style="{minWidth:width+'px',minHeight:height+'px'}">
									<div class="vxe-modal--wrapper type--modal is--visible is--active"
										style="position: absolute;width: 100%;height: 100%;;z-index: 99;">
										<div class="vxe-modal--box"
											style="position: absolute;width: 100%; height: 100%; top: 0px; left: 0px;">
											<div class="vxe-modal--body" style="flex-direction: column;">
												<div class="vxe-modal--content"
													style="box-sizing: border-box;padding: 20px;">
													<slot name="main"></slot>
												</div>
												<div class="vxe-modal--footer">

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="controll_container" v-if="isflow" :style="{opacity:controllShow?1:0}">
					<!-- 					<div class="controll_header">{{(flowprogressid==0 || isfirstnode)?'发起':'协同'}}</div>
					<div class="controll_body" v-if="flowprogressid!=0 && !isfirstnode"> -->
					<div class="controll_header">{{(flowprogressid==0 || isfirstnode)?'发起':'协同'}}</div>
					<div class="controll_body" v-if="flowprogressid!=0 ">
						<div class="controll_header_button">
							<!-- <vxe-button type="text" content="知会" size="mini" icon="vxe-icon-voice"></vxe-button> -->
							<template v-if="cooperateButton">
								<vxe-button v-if="!isfirstnode" type="text" content="指定退回" size="mini"
									icon="vxe-icon-undo" @click="reback">
								</vxe-button>
								<vxe-button type="text" content="转发" size="mini" icon="vxe-icon-send" @click="forward">
								</vxe-button>
								<vxe-button type="text" content="撤销流程" size="mini" icon="vxe-icon-delete"
									@click="deleteflow">
								</vxe-button>
							</template>
							<!-- <vxe-button type="text" content="加签" size="mini" icon="vxe-icon-add"></vxe-button> -->
						</div>

						<div class="controll_body_button">
							<div style="font-size: 12px;margin: 10px 0;">处理意见</div>
							<div class="tinymce">
								<tinymce v-model="comment"></tinymce>
							</div>
						</div>
					</div>
					<div class="controll_body_button" style="box-sizing: border-box;padding: 10px;">
						<div style="font-size: 12px;margin: 10px 0;">流程备注</div>
						<el-input type="textarea" v-model="flowmark"></el-input>
						<div class="flex" style="width: 100%;flex-direction: row;justify-content: flex-end;margin-top: 10px;">
							<vxe-button type="text" content="保存" size="mini" icon="vxe-icon-save" @click="saveFlowmark"></vxe-button>
						</div>
					</div>
										
					<div class="illustrate" v-if="illustrate">操作说明：{{illustrate}}</div>
					<div class="controll_footer_button flex">
						<slot name="footer"></slot>
					</div>
				</div>
				<div class="controll_container" v-if="!isflow" :style="{opacity:controllShow?1:0}">
					<div class="controll_header" v-if="controlltype==1">新增</div>
					<div class="controll_header" v-if="controlltype==2">编辑</div>
					<div class="controll_header" v-if="controlltype==3">预览</div>
					<div class="controll_footer_button flex">
						<slot name="footer"></slot>
					</div>
				</div>
				<!-- 				<vxe-modal v-model="commentShow" width="1000" height="600" :destroy-on-close="true" title="处理人意见区"
					show-footer>
					<template #default>
						<comment :id="id" :name="name" />
					</template>
				</vxe-modal> -->
				
				<flowdetail-index :flowprogressContent="flowprogressContent" ref="flowdetailIndex" :dataid="id" :moduleName="name" :isflow="isflow"  />
				
				
<!-- 				<vxe-modal v-model="flowprogressShow" title="流程详情" width="600" max-height="600" show-footer
					@show="onFlowprogressShow">
					<template #default>
						<el-steps :space="70" direction="vertical" :active="flowprogressContent.length-1"
							style="min-height: 200px;">
							<el-step v-for="(item,index) in flowprogressContent" :key="index" :title="item.title"
								:description="item.time">
							</el-step>
						</el-steps>
					</template>
					<template #footer>
						<vxe-button size="mini" content="返回" @click="flowprogressShow=false"></vxe-button>
					</template>
				</vxe-modal> -->
				
				
				<flowsimulate-index :flowsimulatedata="flowsimulatedata" ref="flowsimulateIndex" />
				
<!-- 				<vxe-modal v-model="flowsimulateShow" title="流程模拟" width="600" height="600" show-footer >
					<template #default>
						<el-steps :space="70" direction="vertical" 
							style="min-height: 200px;">
							<el-step v-for="(item,index) in flowsimulateContent" :key="index" :title="item.title"
								:description="item.description" :status="item.status">
							</el-step>
						</el-steps>
					</template>
					<template #footer>
						<vxe-button size="mini" content="返回" @click="flowsimulateShow=false"></vxe-button>
					</template>
				</vxe-modal> -->
				
				
				<vxe-modal v-model="rebackShow" width="1000" height="600" :destroy-on-close="true" title="指定退回"
					show-footer :before-hide-method="rebackSubmit">
					<template #default>
						<reback ref="reback" :flowprogress="flowprogress" @error="rebackError" />
					</template>
				</vxe-modal>
				<auth v-if="forwardauthShow" ref="forwardauth" :isauth="false" @submit="forwardauthSubmit"
					:extra="{title:'转发对象'}" />
				<slot name="load"></slot>
			</div>
		</template>
	</div>






</template>
<style scoped>
	.left_header {
		width: 100%;
		height: 60px;
		background-color: white;
		box-shadow: 0px 0px 10px grey;
		box-sizing: border-box;
		font-weight: bolder;
		padding: 4px 10px;
	}

	.controll_container {
		color: #606266;
		position: relative;
		width: 300px;
		height: 100%;
		right: 0;
		top: 0;
		background-color: white;
		z-index: 100;
		border-left: 4px solid #DCDFE6;
	}

	.controll_header {
		position: relative;
		width: 100%;
		box-sizing: border-box;
		padding: 5px;
		background: rgb(233, 233, 235);
		text-align: center;
		font-size: 16px;
	}

	.controll_body {
		box-sizing: border-box;
		padding: 0 10px;
	}

	.controll_header_button {
		position: relative;
		width: 100%;
		box-sizing: border-box;
		padding: 5px;
		border-bottom: 1px solid rgb(233, 233, 235);
	}

	.controll_body_button {
		position: relative;
		width: 100%;
		box-sizing: border-box;
		border-bottom: 1px solid rgb(233, 233, 235);
	}

	.tinymce {
		position: relative;
		width: 100%;
		height: 300px;
	}

	.controll_footer_button {
		position: absolute;
		width: 100%;
		box-sizing: border-box;
		padding: 0 10px;
		bottom: 20px;
		flex-direction: row;
		justify-content: flex-end;
	}

	.illustrate {
		text-align: justify;
		margin: 0px 10px;
		margin-top: 10px;
		font-weight: bold;
		font-size: 14px;

	}
</style>
<script>
	import tinymce from '@_system/components/tinymce.vue'
	import comment from './comment.vue'
	import reback from './reback/index.vue'
	import auth from '@_system/components/forms/auth/form.vue'
	import flowsimulateIndex from './flowsimulate/index.vue'
	import flowdetailIndex from '@_system/components/formcomponents/common/flowstatus/flowdetail/index.vue'
	import flowdetailphoneIndex from '@_system/components/formcomponents/phone/flowstatus/flowdetail/index.vue'
	export default {
		props: {
			mainForm: {
				default: () => {
					return null
				}
			},
			id: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			name: {
				type: String,
				default: () => {
					return ''
				}
			},
			controlltype: {
				type: [Number, String],
				defalut: () => {
					return 1
				}
			},
			flowprogressid: {
				type: [Number, String],
				defalut: () => {
					return 0
				}
			},
			isflow: {
				type: [Number, String],
				defalut: () => {
					return 0
				}
			},
			flowid: {
				type: [Number, String],
				defalut: () => {
					return 0
				}
			},
			// loading: {
			// 	type: Boolean,
			// 	default: () => {
			// 		return true
			// 	}
			// },
			width: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			height: {
				type: [Number, String],
				default: () => {
					return 0
				}
			},
			device: {
				type: [String],
				default: () => {
					return window.systemMethods.device()
				}
			},
		},
		data() {
			return {
				commentShow: false,
				rebackShow: false,
				flowsimulateShow:false,
				flowprogressContent: [],
				forwardauthShow: false,
				flowprogressType:0,
				flowprogress: null,
				commentcount: null,
				illustrate: null,
				isfirstnode: false,
				controllShow: false,
				cooperateButton: false,
				flowsimulatedata:[],
				submitMap: [],
				comment:null,
				flowmark:null
			}
		},
		watch: {
			// loading(val) {
			// 	if (!val) {
			// 		this.init()
			// 	}
			// }
		},
		computed: {

		},
		mounted() {
			this.init().then(()=>{
				this.$emit('load')
				this.getFlowmark()
			})
			//console.log(this.controlltype)
		},
		methods: {
			flowprogressShow(){
				this.$refs.flowdetailIndex.modal_show()
			},
			init() {
				return new Promise((reslove)=>{
					let firstnode = null
					let cells = null
					if (this.flowprogressid) {
				
						this.$api.flowprogress.get(this.flowprogressid).then((res) => {
							this.flowprogress = res
							this.flowprogressType = res.current.type
							//this.commentcount = res.commentcount
							this.submitMap = res.submitMap
							cells = res.current.template.flowtemplate.cells
							firstnode = cells.find((item) => {
								return item.data.nodetype == 998
							})
							let currentnode = cells.find((item) => {
								return item.id == res.current.currentnodeid
							})
							
							this.illustrate = currentnode.data.illustrate ? currentnode.data.illustrate : null
							if (res.current.currentnodeid == firstnode.id) {
								this.isfirstnode = true
							}
							
							this.controllShow = true
							if (res.current.currentnodetype == 3) {
								this.cooperateButton = false
							} else {
								this.cooperateButton = true
							}
							reslove()
						})
					} else if (this.flowid) {
						this.$api.flow.get(this.flowid).then((res) => {
							cells = res.flow.cells
							firstnode = cells.find((item) => {
								return item.data.nodetype == 998
							})
							this.illustrate = firstnode.data.illustrate ? firstnode.data.illustrate : null
							this.controllShow = true
							reslove()
						})
					} else {
						
						this.controllShow = true
						reslove()
					}
				})
			},
			flowsimulate(){
				this.mainForm.submit(0,0,1).then((res)=>{
					this.flowsimulatedata = res
					this.$refs.flowsimulateIndex.modal_show()
				})
			},
			getFlowmark(){
				this.$api.flowprogress.getFlowmark({
					id: this.id,
					name: this.name
				}).then((res) => {
					if(res){
						this.flowmark  = res.content			
					}			
				})
			},
			saveFlowmark(){
				this.$api.flowprogress.saveFlowmark({
					id: this.id,
					name: this.name,
					flowprogressid:this.flowprogressid,
					content:this.flowmark
				}).then(() => {
					this.$message.success('操作成功')
				})
			},
			getflowprogress(dataid) {
				this.$api.flowprogress.list({
					dataid: dataid,
					formname: this.name
				}).then((res) => {
					if (!res.length == 0) {
						let flowprogressContent = []
						res.forEach((item, index) => {
							if (item.currentnodetype != 3) {
								let time = window.systemMethods.timestampToDate(item.update_time * 1000)
								let currentstaff = window.systemMethods.getstaff(item.currentstaffid)
								let nextstaffid = item.nextstaffid ? item.nextstaffid.toString().split(
										',') :
									null
								let nextstaff = []
								if (nextstaffid) {
									nextstaffid.forEach((item) => {
										nextstaff.push(window.systemMethods.getstaff(item))
									})
								}
								nextstaff = nextstaff.join('，')
								let current = {
									time: time,
									currentstaff: currentstaff,
									tag: item.tag ? item.tag : '',
									submit: item.submit ? item.submit : ''
								}
								let currenttitle = ''
								currenttitle += current.currentstaff
								if (current.tag) {
									currenttitle += '【' + current.tag + '】'
								}
								if (current.submit) {
									currenttitle += '（' + current.submit + '）'
								}
								current.title = currenttitle
								let next = null
								flowprogressContent.push(current)
								if (index == res.length - 1) {
									if (item.isend != 1) {
										next = {
											time: null,
											currentstaff: nextstaff,
											tag: '待执行',
											submit: ''
										}
									} else {
										next = {
											time: null,
											currentstaff: '',
											tag: '结束',
											submit: ''
										}
									}
								}
								if (next) {
									let nexttitle = ''
									nexttitle += next.currentstaff
									if (next.tag) {
										nexttitle += '【' + next.tag + '】'
									}
									if (next.submit) {
										nexttitle += '（' + next.submit + '）'
									}
									next.title = nexttitle
									flowprogressContent.push(next)
								}

							}

						})

						this.flowprogressContent = flowprogressContent
					}
				})
			},
			onFlowprogressShow() {
				this.getflowprogress(this.id)
			},
			rebackError() {
				this.rebackShow = false
			},
			reback() {

				this.rebackShow = true
			},
			deleteflow() {
				this.$confirm('是否确认撤销？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let handle = this.$loading()
					this.$api.flowprogress.delete(this.flowprogressid).then(() => {
						this.windowClose()
					},()=>{
						this.$loadingclose(handle)
					})
				}).catch(() => {
					
				})
			},
			rebackSubmit(e) {
				if (e.type == 'confirm') {
					let handle = this.$loading()
					let data = this.$refs.reback.submit()
					if (data) {
						this.$api.form.reback(this.flowprogressid, data).then(() => {
							this.windowClose()
							this.$loadingclose(handle)
						})
					} else {
						this.$loadingclose(handle)
						return new Error()
					}

				} else {
					this.rebackShow = false
				}

			},
			forward() {
				this.forwardauthShow = true
			},
			forwardauthSubmit(e) {
				this.forwardauthShow = false
				this.$emit('forward', e)
			},
			windowClose() {
				if (this.device != 'pc') {
					this.$router.go(-1)
				} else {
					window.close()
				}
			}
		},
		components: {
			tinymce,
			comment,
			reback,
			auth,
			flowsimulateIndex,
			flowdetailIndex,
			flowdetailphoneIndex
		}
	}
</script>
